function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#FFF",
  strokeLinecap: "square",
  strokeLinejoin: "bevel",
  strokeWidth: 4,
  d: "M2 2.5v20l17-10z"
});

var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMSIgaGVpZ2h0PSIyNSIgdmlld0JveD0iMCAwIDIxIDI1Ij4KICA8cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiNGRkYiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiIHN0cm9rZS1saW5lam9pbj0iYmV2ZWwiIHN0cm9rZS13aWR0aD0iNCIgZD0iTTE0OCAyMEwxNjggMjAgMTU4IDN6IiB0cmFuc2Zvcm09InJvdGF0ZSg5MCA4My43NSAtNjEuNzUpIi8+Cjwvc3ZnPgo=";
export { SvgPlay as ReactComponent };